// Текущий язык UI, зеркалируемый для НЕ-React кода (например, чокпоинт ошибок API
// в src/api/client.ts — он работает вне дерева компонентов и не читает контекст).
// AppProvider держит это в синхроне при каждой смене языка.
import { AZ_DB } from './az-data'
import type { Lang } from './strings'

let _lang = 'ru'

export function setRuntimeLang(l: string): void {
  _lang = l
}

/** Текущий язык UI — для не-React кода вне AppProvider (например, ErrorBoundary). */
export function getRuntimeLang(): Lang {
  return _lang as Lang
}

/**
 * Перевод строки, пришедшей с бэка/из БД, на азербайджанский при активном `az`;
 * иначе строка проходит как есть. Ключ — точная исходная строка (RU или EN).
 * Строки с подстановками ${…} в словарь не входят и остаются как есть — им нужна
 * локализация шаблонов на бэке.
 */
export function azdb(s: string): string {
  return _lang === 'az' ? AZ_DB[s] ?? s : s
}
